import { Component, OnInit, ViewChild } from '@angular/core';
import { Pagination } from 'src/app/utility/services/paging/paging';
import { MatTableDataSource, MatSort, MatDialog } from '@angular/material';
import { PpoListService } from '../../service/ppo-list/ppo-list.service';
import { NavigateService } from 'src/app/utility/services/navigate/navigate.service';
import { FormBuilder, FormControl, FormGroupDirective, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { ViewletterDialogComponent } from './viewletter-dialog/viewletter-dialog.component';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { PPORequestStatus } from 'src/app/utility/enum/global-enum';
import { IFileExtend } from '../../model/IFileExtend';
import { ValidateClaimGlComponent } from '../validate-claim-gl/validate-claim-gl/validate-claim-gl.component';
import { EnumService } from 'src/app/utility/services/enum-service/enum.service';
import { FileHandlerService } from 'src/app/utility/services/file-handler/file-handler.service';

@Component({
  selector: 'app-ppo-list',
  templateUrl: './ppo-list.component.html',
  styleUrls: ['./ppo-list.component.scss']
})
export class PpoListComponent implements OnInit {

  PPORequestStatus: any = PPORequestStatus;
  public pagination = new Pagination();
  dataSource = new MatTableDataSource();
  search = new FormControl('');
  fileExtends: IFileExtend[];
  isDocSubmission = true;

  isNigoDocumentUploadPageEnable: boolean;
  claimStatues : any;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @ViewChild(ValidateClaimGlComponent, { static: true })
  validateClaimGlComponent: ValidateClaimGlComponent;
  columns: string[] = [
    "sl",
    "ppoRequestId",
    "patientId",
    "patientName",
    "policyNo",
    "certificateNo",
    "product",
    "disease",
    "admissionDate",
    "preApprovalLetter",
    "status",
    "isnigo",
    "action"
  ];

  ppoClaimStatusReportForm = this.fb.group({
    pPOClaimStatusReportType: ['', [Validators.required]],
    fromDate: ['', [Validators.required]],
    toDate: [''],
  });
  

  constructor(private ppoService: PpoListService,
    public dialog: MatDialog,
    private messageService: MessageService,
    private navigateService: NavigateService,
    private enumService: EnumService,
    private fb: FormBuilder,
    private fileHandlerService: FileHandlerService,
  ) { }

  ngOnInit() {
    this.getAllPpoRequests();

    this.search.valueChanges
      .pipe(debounceTime(500))
      .subscribe(
        value => {
            this.applyFilter(value);
        }
      );

    this.getClaimStatues();
    this.ppoClaimStatusReportForm.patchValue({
      pPOClaimStatusReportType: 0,
    });
  }

  getAllPpoRequests() {
    this.ppoService.getDynamicList(this.pagination).subscribe(
      response => {
        this.load(response.data);
        this.pagination.totalCount = response.totalCount;
      },
      err => {
        this.messageService.show(err.error.message, 'error');
      });
  }

  load(data) {
    this.dataSource = new MatTableDataSource(data);
    this.dataSource.sort = this.sort;
  }

  applyFilter(text) {
    this.pagination = new Pagination();
    this.pagination.searchText = text;
    this.getAllPpoRequests();
  }

  ChangePage($event) {
    this.pagination.pageSize = $event.pageSize;
    this.pagination.pageIndex = $event.pageIndex;
    this.getAllPpoRequests();
  }

  addNewCase() {
    this.navigateService.toNewCase();
  }

  showViewLetter(id: number) {
    const dialogRef = this.dialog.open(ViewletterDialogComponent, {
      minWidth: "900px",
      data: id
    });
  }

  addClaimAmount(id: number) {
    this.navigateService.toPpoPreApprovedBillEntry(id);
  }

  submitNigoDocument(ppoRequestId: number, claimEntryId: number) {
    this.navigateService.toNigoDocumentUpload(ppoRequestId, claimEntryId);
    this.isNigoDocumentUploadPageEnable = true;
  }


  documentRequiredValidation() {
    //As All documents are mandatory. So check the number of required document and number of uploaded documents
    let rerquiredfile = 0;
    this.fileExtends.forEach(ele => {
      if (!ele.isOptional) {
        rerquiredfile++;
      }
    });
    let uploadedFile = 0;
    this.fileExtends.forEach(x => {
      if (x.file != null && !x.isOptional) {
        uploadedFile++;
      }
    });

    if (rerquiredfile === uploadedFile) {
      this.isDocSubmission = false;
    } else {
      this.isDocSubmission = true;
    }
  }

  downloadExcel(formDirective: FormGroupDirective) {
    const entity = this.ppoClaimStatusReportForm.getRawValue();
    this.ppoService.downloadExcelReport(entity).subscribe(
      res => {
        this.downloadParse(res);
      },
      err => {
        this.messageService.show(err.error.message, 'error');
      }
    );
  }

  downloadParse(response) {
    if (response.file) {
      const binary = atob(response.file);
      const array = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) { array[i] = binary.charCodeAt(i); }
      this.fileHandlerService.downloadExcel(array, response.filename + ".xlsx");
    } else {
      this.messageService.show(response.message, 'error');
    }
  }

  private getClaimStatues(): void {
    this.enumService.getPPOClaimStatusReportTypes().subscribe(res => {
      this.claimStatues = res;
    },
      err => {
        this.messageService.show(err.error.message, "error");
      });
  }
}
